import { render, staticRenderFns } from "./GymRouteListItem.vue?vue&type=template&id=7156dd38"
import script from "./GymRouteListItem.vue?vue&type=script&lang=js"
export * from "./GymRouteListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports